<div class="popup modal-header w-100 d-inline-block p-4 pb-0 mb-0 text-center">

    <div class="p-4">
      <img  [src]="requestStatus === 'Approved' ? '/assets/icons/approved-approval-request.svg' : '/assets/icons/rejected-approval-request.svg'" class="success">
  
      <h4 class="h4 mb-4">{{requestStatus}}</h4>
      <p *ngIf="requestStatus === 'Approved'" class="my-4">The request has been successfully approved. A notification has been sent to the necessary parties
      </p>
      <p *ngIf="requestStatus === 'Rejected'" class="my-4">The approval request has been rejected. A notification has been sent to the necessary parties
      </p>
      <div *ngIf="requestStatus === 'Approved'" class="mb-4">
        <button (click)="viewBooking()" class="btn btn-resend w-100 ">View Booking</button>
      </div>
      <div *ngIf="requestStatus === 'Rejected'" class="mb-4">
        <button (click)="viewBookingRejected()" class="btn btn-resend w-100 ">View Booking</button>
      </div>
      <div>
        <p class="close" (click)="close()">close</p>
      </div>
    </div>
  </div>
  